module.exports = __webpack_public_path__ + "img/第1档.3d663260.png";